// import { Container } from '@mui/material';
import React from 'react';
import Justfortestblog from './Justfortestblog';
// import { Col, Row } from 'react-bootstrap';
// import Justfortestblog from './justfortestblog';
// import LatestBlogs from './LatestBlogs';
// import SiteContents from './SiteContents';

const Blog = () => {

    return (
        <div id="blog_area_page1">
            <Justfortestblog/>
            {/* <Container maxWidth="lg">
                <Row>
                    <Col md={9}>
                        <LatestBlogs />
                    </Col>
                    <Col md={3}>
                        <SiteContents />
                    </Col>
                </Row>
            </Container> */}
        </div>
    );
};

export default Blog;